import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * library-show operation
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const showLibrary = async ({
  request,
}: {
  request: ApiTypes["library-show"]["request"];
}): Promise<ApiTypes["library-show"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["library-show"]["response"]
    >(`/api/public/v2025-06/playlists`, request);
    return response.data;
  } catch (error) {
    handleApiError(error as Error, "Failed to showLibrary");
    throw error;
  }
};
